document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-avx-producto]');
  if (!root) return;

  var minis = root.querySelectorAll('[data-avx-mini]');
  var slides = root.querySelectorAll('[data-avx-slide]');

  function showSlide(id) {
    slides.forEach(function (s) { s.classList.toggle('is-active', s.id === id); });
    minis.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-target') === id); });
  }

  minis.forEach(function (m) {
    m.addEventListener('click', function () { showSlide(m.getAttribute('data-target')); });
  });

  function slideArray() { return Array.prototype.slice.call(slides); }
  function currentIndex() {
    var arr = slideArray();
    for (var i = 0; i < arr.length; i++) if (arr[i].classList.contains('is-active')) return i;
    return 0;
  }
  var prevBtn = root.querySelector('[data-avx-prev]');
  var nextBtn = root.querySelector('[data-avx-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    var arr = slideArray();
    if (!arr.length) return;
    var next = (currentIndex() - 1 + arr.length) % arr.length;
    showSlide(arr[next].id);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    var arr = slideArray();
    if (!arr.length) return;
    var next = (currentIndex() + 1) % arr.length;
    showSlide(arr[next].id);
  });

  var generoBtns = root.querySelectorAll('[data-avx-genero]');
  function setGenero(g) {
    generoBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-avx-genero') === g); });
    root.querySelectorAll('[data-avx-us]').forEach(function (el) {
      el.textContent = 'US ' + el.getAttribute(g === 'm' ? 'data-us-m' : 'data-us-h');
    });
  }
  if (generoBtns.length) {
    var guardado = null;
    try { guardado = window.localStorage.getItem('avx-genero'); } catch (e) {}
    if (guardado === 'm') setGenero('m');
    generoBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-avx-genero');
        setGenero(g);
        try { window.localStorage.setItem('avx-genero', g); } catch (e) {}
      });
    });
  }

  var form = root.querySelector('[data-avx-form]');
  if (!form) return;
  var variantsScript = form.querySelector('[data-avx-variants]');
  var preciosScript = form.querySelector('[data-avx-precios]');
  if (!variantsScript) return;

  var variants = JSON.parse(variantsScript.textContent || '[]');
  var precios = preciosScript ? JSON.parse(preciosScript.textContent || '{}') : {};
  var idInput = form.querySelector('[data-avx-variant-id]');
  var addBtn = form.querySelector('[data-avx-add]');
  var addText = form.querySelector('[data-avx-add-text]');
  var priceEl = root.querySelector('[data-avx-precio-actual]');

  var optionGroups = root.querySelectorAll('[data-avx-opcion-valores]');
  var selected = [];
  optionGroups.forEach(function (group, idx) {
    var active = group.querySelector('.is-selected');
    selected[idx] = active ? active.getAttribute('data-value') : null;
  });

  function findVariant() {
    return variants.filter(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val == null || opts[i] === val; });
    })[0];
  }

  function updateUI(variant) {
    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = addBtn.getAttribute('data-label-unavailable') || 'No disponible';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl && precios[variant.id]) priceEl.textContent = precios[variant.id];
    if (variant.available) {
      if (addBtn) addBtn.disabled = false;
      if (addText) addText.textContent = addBtn.getAttribute('data-label-add');
    } else {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = addBtn.getAttribute('data-label-soldout');
    }
  }

  root.querySelectorAll('[data-avx-option-index]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.getAttribute('data-avx-option-index'), 10);
      var group = btn.closest('[data-avx-opcion-valores]');
      if (group) group.querySelectorAll('.avx-producto__talla').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selected[idx] = btn.getAttribute('data-value');
      updateUI(findVariant());
    });
  });
});
